import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import './Nav.css';
import PopUp from '../searchNav/popUp/PopUp';
import { useTranslation } from 'react-i18next';

function Nav() {
  const { t, i18n } = useTranslation();

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);  // เก็บภาษาที่เลือกลงใน localStorage
    setIsDropdownOpen(false);
    setSelectedLanguage(lng);
  };

  const [isMobile, setIsMobile] = useState(false);
  const [modalShow, setModalShow] = useState(false);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  // const changeLanguage = (language) => {
  //   setSelectedLanguage(language);
  //   setIsDropdownOpen(false); // Close the dropdown after selecting
  //   console.log('Language changed to: ', language);
  //   // Add your language change logic here (e.g., i18n.changeLanguage(language))
  // };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="row nav">
      <div className="col-12 text-capitalize  ">
        <header className="d-flex justify-content-between ">
          <PopUp show={modalShow} onHide={() => setModalShow(false)} />
          <div className="justify-content-start text-center">
            <Link className="log text-light" style={{ fontSize: "18px", fontWeight: "bold", textDecoration: "none" }} to='/'>
              <img
                src={require("../../assets/RN69.png")}
                alt="RN69"
                width={100}
              />
            </Link>
          </div>

          {/* <div className="col- d-none d-lg-block">
          </div> */}

          <div className="d-flex justify-content-center align-items-center text-center gap-2">
            <button
              className="btn bg-danger btn-sm text-white text-capitalize"
              onClick={() => window.location.href = process.env.REACT_APP_LOGIN}
            >
              {t('login')}
            </button>

            <button
              className="btn bg-success-1 btn-sm text-white text-capitalize"
              onClick={() => { window.location.href = process.env.REACT_APP_REGISTER }}
            >
              {t('signup')}
            </button>

            <div className="language-selector">
              <div className="dropdown-btn" onClick={toggleDropdown}>
                <img
                  src={require(`../../assets/${selectedLanguage}-flag.png`)} // Replace with actual flag image paths
                  alt={selectedLanguage}
                  className="flag"
                />
                <span>{selectedLanguage.toUpperCase()}</span>
              </div>
              {isDropdownOpen && (
                <div className="dropdown">
                  <a href="#" onClick={() => changeLanguage('en')}>
                    <img src={require("../../assets/en-flag.png")} alt="English" className="flag" /> EN
                  </a>
                  <a href="#" onClick={() => changeLanguage('khm')}>
                    <img src={require("../../assets/khm-flag.png")} alt="Cambodian" className="flag" /> KHM
                  </a>
                  <a href="#" onClick={() => changeLanguage('cn')}>
                    <img src={require("../../assets/cn-flag.png")} alt="Chinese" className="flag" /> CN
                  </a>
                </div>
              )}
            </div>
          </div>
        </header>
      </div>
    </div>
  );
}

export default Nav;
